import { useState } from "react";
import { useAppSelector } from "@/redux/features/hooks";
import ConsumptionReport from "@/components/inventory/reports/ConsumptionReport";
import WasteReport from "@/components/inventory/reports/WasteReport";
import MarginReport from "@/components/inventory/reports/MarginReport";
import { cn } from "@/lib/utils";

type ReportTab = "consumption" | "waste" | "margin";

const TABS: { id: ReportTab; label: string }[] = [
  { id: "consumption", label: "Consommation" },
  { id: "waste", label: "Pertes" },
  { id: "margin", label: "Marge" },
];

const InventoryReportsPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  const [activeTab, setActiveTab] = useState<ReportTab>("consumption");

  if (!restaurant) return null;

  return (
    <div className="space-y-4">
      <nav className="flex gap-1 border-b border-border overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              "px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors",
              activeTab === tab.id
                ? "border-primary text-primary"
                : "border-transparent text-muted-foreground hover:text-card-foreground hover:border-border"
            )}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {activeTab === "consumption" && (
        <ConsumptionReport restaurantId={restaurant.id} />
      )}
      {activeTab === "waste" && <WasteReport restaurantId={restaurant.id} />}
      {activeTab === "margin" && <MarginReport restaurantId={restaurant.id} />}
    </div>
  );
};

export default InventoryReportsPage;
